<app-profile-header></app-profile-header>
<section class="body-section Partner-request">
    <div class="container">
        <main>
            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box ">
                    <div class="mobile-header-stickybackButton"><a onclick="history.back()"
                        class="mobile-header"><i class="bx bx-chevron-left"
                            style=" font-size: 1.6em;"></i> Back </a></div>

                    <!-- <div class="header-container">
                        <h3 class="section-header desktp">Contest History</h3>
                        <div class="title-back-button">
                            <a  onclick="history.back()">
                                <span><i class="pi pi-chevron-left" style=" font-family: 'primeicons'; color: #fff;"></i></span>
                                <h3 class="section-header">Contest History</h3>
                            </a>
                        </div>
                    </div> -->
                    <h3 class="mobile-page-title">Contest History</h3>
            <p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
                <p-tabPanel header="All Contest" *ngIf="contestList">
                    <div class="contest-page-list col-md-12 px-4">
                        <!-- <div class="row"> -->
                        <!---Contest Main List Start--->
                        <div *ngFor="let contest of contestList" class="col-md-12 contest-main-list ">
                            <div class="joincontestlist p-0">
                                <div class="match-tournament contest ds-truncate w-100">
                                    <div class="col-md-8 categoryname">
                                        <h5 class="prize-pool-heading left-heading">
                                            {{contest.displaytournamentName}}
                                        </h5>
                                    </div>
                                    <div class="col-md-4 prizepool">
                                        <h5 class="prize-pool-heading right-heading">
                                            {{contest.tournamentCategoryName}}
                                        </h5>
                                    </div>
                                </div>
                                <div class="col-md-12 list col-sm-12">
                                    <div class="left-side-body media-body w-100 row mb-0">
                                        <div class="col-md-7 col-sm-12">
                                            <div
                                                class="join-contest-body media contest-main-div-userimage {{contest.tournamentName}}">
                                                <div class="tems-image">
                                                    <div class="team-1">
                                                        <img src="{{contest.player1Image}}" alt=""
                                                            class="single-div">
                                                        <div class="user-image double-contest-div">
                                                            <p-avatarGroup styleClass="mb-1 ">
                                                                <p-avatar image="{{contest.player1Image}}"
                                                                    size="large" shape="circle"></p-avatar>
                                                                <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                size="large" shape="circle"></p-avatar> -->
                                                            </p-avatarGroup>
                                                        </div>
                                                        <div class="name">
                                                            <h4 class="title" [innerHTML]="contest.player1Name">

                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div class="middle">VS</div>
                                                    <div class="team-2">
                                                        <img src="{{contest.player2Image}}" alt=""
                                                            class="single-div">
                                                        <!--Below Code is testing for double image please remove this code when it's come dynamic value --->
                                                        <div class="user-image double-contest-div">
                                                            <p-avatarGroup styleClass="mb-1 ">
                                                                <p-avatar image="{{contest.player2Image}}"
                                                                    size="large" shape="circle"></p-avatar>
                                                                <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                size="large" shape="circle"></p-avatar> -->
                                                            </p-avatarGroup>
                                                        </div>
                                                        <div class="name">
                                                            <h4 class="title" [innerHTML]="contest.player2Name">

                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="match-date">
                                                <!-- <p style="font-size: 14px;text-align: center;font-weight: 700;"
                                            class="date-time-location">
                                            {{contest.tournamentName}}</p> -->
                                                <h3 style="font-size: 14px;text-align: center;">
                                                    {{contest.matchDate|date:'MMMM d, y, h:mm a'}}
                                                </h3>
                                                <h3 class="timer-section-heading"><span
                                                        class="time-bold">{{contest['displayTime']}}</span>
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-3 price-pool-div">

                                            <div class="price-pool-section">
                                                <div class="error-icon">
                                                   
                                                    <a (click)="showPrizePoolNewstructure(contest)" style="cursor: pointer;"><i class='bx bx-error-circle'></i></a>
                                                </div>
                                                <div class="price-pool-text heading3">
                                                    <h5>Prize Pool </h5>
                                                </div>
                                                <div class="price-pool-number1"
                                                    *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                    <span class="price-pool-number">
                                                        {{contest.updatedPoolCoins}}
                                                    </span>
                                                    <p class="tpl-cash-coins"> TPL Coins</p>
                                                </div>
                                                <div class="price-pool-number1"
                                                    *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                    <span class="price-pool-number">
                                                        <i class='bx bx-rupee'></i>{{contest.updatedPoolCash}}
                                                    </span> <br>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-2 entry-fee-section">
                                            <div class="entery-fee">
                                                <h4 class="fee-text">ENTRY FEE</h4>
                                                <div class="fees-entry">
                                                    <!-- <span class="fees-number">120</span> -->
                                                    <span class="fees-number" *ngIf="contest.entryFee > 0">
                                                        <i class='bx bx-rupee' *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"></i>{{contest.entryFee}}
                                                    </span>
                                                    <span class="fees-number" *ngIf="contest.entryFee == 0">
                                                        Free
                                                    </span>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                        <span class="entry_fees"> TPL Coins</span>
                                                    </div>
                                                    <!-- <span *ngIf="contest.entryFee > 0">
                                            {{contest.entryFee|currency:'INR'}}
                                        </span>
                                        <span *ngIf="contest.entryFee == 0">
                                            Free
                                        </span> -->
                                                </div>
                                                <div class="footer-join contest-footer-right">
                                                    <div class="join-btn">
                                                        <button *ngIf="contest.isContestRegistrationComplete"
                                                            class="contest-btn"
                                                            (click)="onClickViewLeaderBoard(contest.contestId)">
                                                           <span>View</span> Leaderboard<i
                                                                class="bx bx-right-arrow-alt"></i>
                                                        </button>
                                                        <button *ngIf="!contest.isContestRegistrationComplete"
                                                            class="contest-btn"
                                                            (click)="onClickRejoin(contest.contestId)">
                                                            Resume<i class="bx bx-right-arrow-alt"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <!-- <div class="hr-bottom web">
                                            <h5 class="number-of-entries">Number Of Entries:</h5>
                                        </div> -->
                                    </div>

                                    <div class="col-12 price-pool-div">

                                        <div class="row">
                                            <div class="col-6 prize-pool-section">

                                                <div class="price-pool-section">
                                                    <div class="error-icon">
                                                        <a (click)="showPrizePoolNewstructure(contest)"
                                                            style="cursor: pointer;"><i
                                                                class='bx bx-error-circle'></i></a>
                                                    </div>
                                                    <div class="price-pool-text heading3">
                                                        <h5 class="mb-0">Prize Pool</h5>
                                                    </div>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                        <span class="price-pool-number">
                                                            {{contest.updatedPoolCoins}}
                                                        </span>
                                                        <p class="tpl-cash-coins"> TPL Coins</p>
                                                    </div>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                        <span class="price-pool-number">
                                                            <i class='bx bx-rupee'></i>{{contest.updatedPoolCash}}
                                                        </span> <br>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6 entry-fee-section">
                                                <div class="entery-fee">
                                                    <h4 class="fee-text">ENTRY FEE</h4>
                                                    <div class="fees-entry">
                                                        <!-- <span class="fees-number">120</span> -->
                                                        <span class="fees-number" *ngIf="contest.entryFee > 0">
                                                            <i class='bx bx-rupee' *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"></i>{{contest.entryFee}}
                                                        </span>
                                                        <span class="fees-number" *ngIf="contest.entryFee == 0">
                                                            Free
                                                        </span>
                                                        <div class="price-pool-number1"
                                                            *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                            <span class="entry_fees"> TPL Coins</span>
                                                        </div>
                                                    </div>
                                                    <div class="footer-join contest-footer-right">
                                                        <div class="join-btn">
                                                            <button
                                                                *ngIf="contest.isContestRegistrationComplete"
                                                                class="contest-btn"
                                                                (click)="onClickViewLeaderBoard(contest.contestId)">
                                                                <span>View</span> Leaderboard<i
                                                                    class="bx bx-right-arrow-alt"></i>
                                                            </button>
                                                            <button
                                                                *ngIf="!contest.isContestRegistrationComplete"
                                                                class="contest-btn"
                                                                (click)="onClickRejoin(contest.contestId)">
                                                                Resume<i
                                                                    class="bx bx-right-arrow-alt"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- <div class="col-3">

                                </div>
                                <div class="col-6 text-center">
                                    <div class="price-pool-section">
                                        <div class="price-pool-text">
                                            Prize Pool  
                                        </div>
                                    <div class="price-pool-number1"  *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                        <span class="price-pool-number">
                                            {{contest.updatedPoolCoins}}
                                        </span> 
                                        <p class="tpl-cash-coins"> TPL Coins</p>
                                    </div>
                                    <div class="price-pool-number1" *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                        <span>
                                            {{contest.updatedPoolCash}}
                                        </span> <br>
                                        <p>TPL Cash</p>
                                    </div>
                                    </div>
                                    
                                </div>
                                <div class="col-3">
                                    <div class="entery-fee">
                                        <h4 class="fee-text">ENTRY FEE</h4>
                                        <h5 class="entry_fees"><span class="fees-number">120</span>TPL Money</h5>
                                    </div>
                                </div> -->
                                        </div>

                                    </div>
                                    <div class="hr-bottom mobile">
                                        <h5 class="number-of-entries">Number Of Entries: {{contest.totalEntries}}</h5>
                                    </div>
                                    <div class="hr-bottom web">
                                        <h5 class="number-of-entries">Number Of Entries: {{contest.totalEntries}}</h5>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <!---Contest Main List End--->
                        <!-- <div *ngIf="isContestAvailable">
                            <div class="not-found-section">
                                <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif"
                                        alt="">
                                    <h4>No Contest Available!</h4>
                                    <p>Please check back later for updates or explore other ongoing contest.</p>
                                </div>
                            </div>

                        </div> -->
                        <!-- <div class="pagination-div">
                    <p-paginator *ngIf="contestList.length > 0" [rows]="10" #paginator
                        [totalRecords]="totalContestRecords" (onPageChange)="loadContest($event, mode)"
                        [rowsPerPageOptions]=" pagination"></p-paginator>
                </div> -->



                        <div *ngIf="contestTotalRecords == 0" class="w-100 contest-not-found">
                            <div class="not-found-section">
                                <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif"
                                        alt="">
                                    <h4>No Contest Available!</h4>
                                    <p>Please check back later for updates or explore other ongoing contest.</p>
                                </div>
                            </div>
                        </div>
                        <div class="pagination-div">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                In total there are
                                {{totalAllContestRecords }} Contest History.
                            </div>
                            <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="totalAllContestRecords" pageLinkSize="3" [showPageLinks]="true"
                                (onPageChange)="loadContest($event, mode)" [first]="(pageNumberFirst - 1) * pageLimitFirst" [rowsPerPageOptions]=" pagination"></p-paginator>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="Resume Contest" *ngIf="rejoincontestList">
                    <div class="contest-page-list col-md-12 px-4">
                        <!-- <div class="row"> -->
                        <!---Contest Main List Start--->
                        <div *ngFor="let contest of rejoincontestList" class="col-md-12 contest-main-list ">
                            <div class="joincontestlist p-0">
                                <div class="match-tournament contest ds-truncate w-100">
                                    <div class="col-md-8 categoryname">
                                        <h5 class="prize-pool-heading left-heading">
                                            {{contest.displaytournamentName}}
                                        </h5>
                                    </div>
                                    <div class="col-md-4 prizepool">
                                        <h5 class="prize-pool-heading right-heading">
                                            {{contest.tournamentCategoryName}}
                                        </h5>
                                    </div>
                                </div>
                                <div class="col-md-12 list col-sm-12">
                                    <div class="left-side-body media-body w-100 row mb-0">
                                        <div class="col-md-7 col-sm-12">
                                            <div
                                                class="join-contest-body media contest-main-div-userimage {{contest.tournamentName}}">
                                                <div class="tems-image">
                                                    <div class="team-1">
                                                        <img src="{{contest.player1Image}}" alt=""
                                                            class="single-div">
                                                        <div class="user-image double-contest-div">
                                                            <p-avatarGroup styleClass="mb-1 ">
                                                                <p-avatar image="{{contest.player1Image}}"
                                                                    size="large" shape="circle"></p-avatar>
                                                                <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                            size="large" shape="circle"></p-avatar> -->
                                                            </p-avatarGroup>
                                                        </div>
                                                        <div class="name">
                                                            <h4 class="title" [innerHTML]="contest.player1Name">

                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div class="middle">VS</div>
                                                    <div class="team-2">
                                                        <img src="{{contest.player2Image}}" alt=""
                                                            class="single-div">
                                                        <!--Below Code is testing for double image please remove this code when it's come dynamic value --->
                                                        <div class="user-image double-contest-div">
                                                            <p-avatarGroup styleClass="mb-1 ">
                                                                <p-avatar image="{{contest.player2Image}}"
                                                                    size="large" shape="circle"></p-avatar>
                                                                <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                            size="large" shape="circle"></p-avatar> -->
                                                            </p-avatarGroup>
                                                        </div>
                                                        <div class="name">
                                                            <h4 class="title" [innerHTML]="contest.player2Name">

                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="match-date">
                                                <!-- <p style="font-size: 14px;text-align: center;font-weight: 700;"
                                                        class="date-time-location">
                                                        {{contest.tournamentName}}</p> -->
                                                <h3 style="font-size: 14px;text-align: center;">
                                                    {{contest.matchDate|date:'MMMM d, y, h:mm a'}}
                                                </h3>
                                                <h3 class="timer-section-heading"><span
                                                        class="time-bold">{{contest['displayTime']}}</span>
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-3 price-pool-div">

                                            <div class="price-pool-section">
                                                <div class="error-icon">
                                                    <a (click)="showPrizePoolNewstructure(contest)" style="cursor: pointer;"><i
                                                            class='bx bx-error-circle'></i></a>
                                                </div>
                                                <div class="price-pool-text heading3">
                                                    <h5>Prize Pool</h5>
                                                </div>
                                                <div class="price-pool-number1"
                                                    *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                    <span class="price-pool-number">
                                                        {{contest.updatedPoolCoins}}
                                                    </span>
                                                    <p class="tpl-cash-coins"> TPL Coins</p>
                                                </div>
                                                <div class="price-pool-number1"
                                                    *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                    <span class="price-pool-number">
                                                        <i class='bx bx-rupee'></i>{{contest.updatedPoolCash}}
                                                    </span> <br>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2 entry-fee-section">
                                            <div class="entery-fee">
                                                <h4 class="fee-text">ENTRY FEE</h4>
                                                <div class="fees-entry">
                                                    <!-- <span class="fees-number">120</span> -->
                                                    <span class="fees-number" *ngIf="contest.entryFee > 0">
                                                        <i class='bx bx-rupee' *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"></i>{{contest.entryFee}}
                                                    </span>
                                                    <span class="fees-number" *ngIf="contest.entryFee == 0">
                                                        Free
                                                    </span>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                        <span class="entry_fees"> TPL Coins</span>
                                                    </div>
                                                    <!-- <span *ngIf="contest.entryFee > 0">
                                                        {{contest.entryFee|currency:'INR'}}
                                                    </span>
                                                    <span *ngIf="contest.entryFee == 0">
                                                        Free
                                                    </span> -->
                                                </div>
                                                <div class="footer-join contest-footer-right">
                                                    <div class="join-btn">
                                                        <button *ngIf="contest.isContestRegistrationComplete"
                                                            class="contest-btn"
                                                            (click)="onClickViewLeaderBoard(contest.contestId)">
                                                            <span>View</span> Leaderboard<i
                                                                class="bx bx-right-arrow-alt"></i>
                                                        </button>
                                                        <button *ngIf="!contest.isContestRegistrationComplete"
                                                            class="contest-btn"
                                                            (click)="onClickRejoin(contest.contestId)">
                                                            Resume<i class="bx bx-right-arrow-alt"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <!-- <div class="hr-bottom web">
                                            <h5 class="number-of-entries">Number Of Entries:</h5>
                                        </div> -->
                                    </div>
                                    <div class="col-12 price-pool-div">

                                        <div class="row">
                                            <div class="col-6 prize-pool-section">

                                                <div class="price-pool-section">
                                                    <div class="error-icon">
                                                        <a (click)="showPrizePoolNewstructure(contest)" style="cursor: pointer;"><i class='bx bx-error-circle'></i></a>
                                                    </div>
                                                    <div class="price-pool-text heading3">
                                                        <h5 class="mb-0">Prize Pool </h5>
                                                    </div>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                        <span class="price-pool-number">
                                                            {{contest.updatedPoolCoins}}
                                                        </span>
                                                        <p class="tpl-cash-coins"> TPL Coins</p>
                                                    </div>
                                                    <div class="price-pool-number1"
                                                        *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                        <span class="price-pool-number">
                                                            <i class='bx bx-rupee'></i>{{contest.updatedPoolCash}}
                                                        </span> <br>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6 entry-fee-section">
                                                <div class="entery-fee">
                                                    <h4 class="fee-text">ENTRY FEE</h4>
                                                    <div class="fees-entry">
                                                        <!-- <span class="fees-number">120</span> -->
                                                        <span class="fees-number" *ngIf="contest.entryFee > 0">
                                                            <i class='bx bx-rupee' *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"></i>{{contest.entryFee}}
                                                        </span>
                                                        <span class="fees-number" *ngIf="contest.entryFee == 0">
                                                            Free
                                                        </span>
                                                        <div class="price-pool-number1"
                                                            *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                            <span class="entry_fees"> TPL Coins</span>
                                                        </div>
                                                    </div>

                                                    <div class="footer-join contest-footer-right">
                                                        <div class="join-btn">
                                                            <button
                                                                *ngIf="contest.isContestRegistrationComplete"
                                                                class="contest-btn"
                                                                (click)="onClickViewLeaderBoard(contest.contestId)">
                                                                <span>View</span> Leaderboard<i
                                                                    class="bx bx-right-arrow-alt"></i>
                                                            </button>
                                                            <button
                                                                *ngIf="!contest.isContestRegistrationComplete"
                                                                class="contest-btn"
                                                                (click)="onClickRejoin(contest.contestId)">
                                                                Resume Contest<i
                                                                    class="bx bx-right-arrow-alt"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <!-- <div class="hr-bottom mobile">
                                                <h5 class="number-of-entries">Number Of Entries:</h5>
                                            </div> -->
                                            <!-- <div class="col-3">
    
                                            </div>
                                            <div class="col-6 text-center">
                                                <div class="price-pool-section">
                                                    <div class="price-pool-text">
                                                        Prize Pool  
                                                    </div>
                                                <div class="price-pool-number1"  *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                    <span class="price-pool-number">
                                                        {{contest.updatedPoolCoins}}
                                                    </span> 
                                                    <p class="tpl-cash-coins"> TPL Coins</p>
                                                </div>
                                                <div class="price-pool-number1" *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                    <span>
                                                        {{contest.updatedPoolCash}}
                                                    </span> <br>
                                                    <p>TPL Cash</p>
                                                </div>
                                                </div>
                                                
                                            </div>
                                            <div class="col-3">
                                                <div class="entery-fee">
                                                    <h4 class="fee-text">ENTRY FEE</h4>
                                                    <h5 class="entry_fees"><span class="fees-number">120</span>TPL Money</h5>
                                                </div>
                                            </div> -->
                                        </div>

                                    </div>
                                    <div class="hr-bottom mobile">
                                        <h5 class="number-of-entries">Number Of Entries: {{contest.totalEntries}}</h5>
                                    </div>
                                    <div class="hr-bottom web">
                                        <h5 class="number-of-entries">Number Of Entries: {{contest.totalEntries}}</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!---Contest Main List End--->
                        <div *ngIf="totalRecordsForRejoin == 0" class="w-100 contest-not-found">
                            <div class="not-found-section">
                                <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif"
                                        alt="">
                                    <h4>No Contest Available to Resume!</h4>
                                    <p>Please check back later for updates or explore other ongoing contest.</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="pagination-div">
                                <p-paginator *ngIf="contestList.length > 0" [rows]="10" #paginator
                                    [totalRecords]="totalContestRecords" (onPageChange)="loadContest($event, mode)"
                                    [rowsPerPageOptions]=" pagination"></p-paginator>
                            </div> -->
                            <div class="pagination-div">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are
                                    {{totalRecordsForRejoin }} Resume contests.
                                </div>
                                <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="totalRecordsForRejoin" pageLinkSize="3" [showPageLinks]="true"
                                    (onPageChange)="loadContestForRejoin($event, mode)" [first]="(pageNumberFirst - 1) * pageLimitFirst" [rowsPerPageOptions]="pagination"></p-paginator>
                            </div>

                    </div>


                </p-tabPanel>
            </p-tabView>
                </div>
            </div>
        </main>
    </div>
</section>
<!-- <p-dialog header="Contest Prize Pool Structure " [(visible)]="pricePoolStructurePopup" [modal]="true"
    class="prize-pool-structure" [style]="{ width: '30%' }" [draggable]="false" [resizable]="false"
    id="poolStructurePopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="col-md-12 p-p-0">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" class="entries-position">Position</th>
                    <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 <br class="mobile-version-br">
                        Entries</th>
                    <th scope="col" class="entries-position" *ngIf="sevenToTen">7 to 10 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="eightToTwelve">8 to 12 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirteenToEighteen">13 to 18 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ <br
                            class="mobile-version-br">Entries</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngIf="twoToFour || fiveToSeven || sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">1st</th>
                    <td class="table-data" *ngIf="twoToFour">100%</td>
                    <td class="table-data" *ngIf="fiveToSeven">65%</td>
                    <td class="table-data" *ngIf="sevenToTen">50%</td>
                    <td class="table-data" *ngIf="eightToTwelve">50%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">40%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">40%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">33%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">29%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                </tr>
                <tr
                    *ngIf="fiveToSeven || sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">2nd</th>
                    <td class="table-data" *ngIf="fiveToSeven">35%</td>
                    <td class="table-data" *ngIf="sevenToTen">30%</td>
                    <td class="table-data" *ngIf="eightToTwelve">30%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">30%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">23%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">20%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">18%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                </tr>
                <tr
                    *ngIf="sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">3rd</th>
                    <td class="table-data" *ngIf="sevenToTen">20%</td>
                    <td class="table-data" *ngIf="eightToTwelve">20%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">20%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">16%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">15%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                </tr>
                <tr
                    *ngIf="thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">4th</th>
                    <td class="table-data" *ngIf="thirteenToEighteen">10%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">12%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">10%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                </tr>
                <tr
                    *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">5th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">9%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">6th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">7%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>

                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">7th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">6%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">8th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">9th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                </tr>
                <tr *ngIf="fiftyOnePlus">
                    <th scope="row" class="entries-position">10th</th>
                    <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog> -->


<p-dialog header="Contest Prize Pool Structure " [(visible)]="pricePoolStructurePopup" [modal]="true"
class="prize-pool-structure" [style]="{ width: '30%' }" [draggable]="false" [resizable]="false"
id="poolStructurePopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="col-md-12 p-p-0">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" class="entries-position">Position</th>
                    <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 <br class="mobile-version-br">
                        Entries</th>
                    <th scope="col" class="entries-position" *ngIf="eightToTen">8 to 10 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="elevenToThirteen">11 to 13 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fourteenToEighteen">14 to 18 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ <br
                            class="mobile-version-br">Entries</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngIf="twoToFour || fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">1st</th>
                    <td class="table-data" *ngIf="twoToFour">100%</td>
                    <td class="table-data" *ngIf="fiveToSeven">65%</td>
                    <td class="table-data" *ngIf="eightToTen">50%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">40%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">40%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">33%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">29%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">28%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                </tr>
                <tr
                    *ngIf="fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">2nd</th>
                    <td class="table-data" *ngIf="fiveToSeven">35%</td>
                    <td class="table-data" *ngIf="eightToTen">30%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">30%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">23%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">20%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">18%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">16%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                </tr>
                <tr
                    *ngIf="eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">3rd</th>
                    <td class="table-data" *ngIf="eightToTen">20%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">20%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">16%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">15%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">14%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                </tr>
                <tr
                    *ngIf="elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">4th</th>
                    <td class="table-data" *ngIf="elevenToThirteen">10%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">12%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">11%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">11%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                </tr>
                <tr
                    *ngIf="fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">5th</th>
                    <td class="table-data" *ngIf="fourteenToEighteen">9%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">8%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">9%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">9%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                </tr>
                <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">6th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">7%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">8%</td>

                </tr>
                <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">7th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">6%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">8th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">5%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">9th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                </tr>
                <tr *ngIf="fiftyOnePlus">
                    <th scope="row" class="entries-position">10th</th>
                    <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>